/**
 * CDN URL helpers for app resources. Centralises the appresources.skitude.com
 * base URL so it only lives in one place.
 */

const CDN_BASE = 'https://appresources.skitude.com'

/**
 * @param {string} appUuid
 * @param {string} versionUuid
 * @returns {string} e.g. "https://appresources.skitude.com/<app>/<version>"
 */
export function getResourcesBaseUrl(appUuid, versionUuid) {
    return `${CDN_BASE}/${appUuid}/${versionUuid}`
}

/**
 * @param {string} appUuid
 * @param {string} versionUuid
 * @param {string} fontName
 */
export function getFontUrl(appUuid, versionUuid, fontName) {
    return `${getResourcesBaseUrl(appUuid, versionUuid)}/delivery/fonts/${fontName}.ttf`
}

/**
 * Background image URL for a menu's phone-screen body.
 *
 * @param {string} appUuid
 * @param {string} versionUuid
 * @param {string} menuType    one of 'home' | 'selector' | 'profile'
 * @param {string} timeofyear  one of 'winter' | 'summer'
 */
export function getBackgroundImageUrl(appUuid, versionUuid, menuType, timeofyear) {
    const base = getResourcesBaseUrl(appUuid, versionUuid)
    const folder = `${base}/processed/webp/Android-xxxhdpi/`
    const names = {
        home:     'background_home',
        selector: 'background_resort_selector',
        profile:  'background_profile',
    }
    let name = names[menuType] || 'background_home'
    if (timeofyear === 'summer') name = `${name}_summer`
    return `${folder}${name}.webp`
}
